import { Injectable,Component }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthService } from "angularx-social-login";
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { SessionHandler } from './session-handler.service';
import {Observable} from 'rxjs';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { LoaderService } from '../../loader/loader.service';
import { dialogComponent } from '../../dialog/dialog.component';
import { Router } from '@angular/router';
import {APPCONFIG} from '../../config';
declare const gapi: any;

@Injectable()
export class HttpService {
    AppConfig;
    public url = APPCONFIG.appUrl;
    //public url = 'http://localhost:8080';
    id_token: string;

    public dialogRef;
    public headers = new Headers({'Content-Type': 'application/json','apiKey':'AIzaSyDnTiD1XwEfvVYZCk6I_i5M59lDKZpqH6o','Access-Control-Allow-Origin':'*','Cache-Control':'no-cache' ,'Pragma':'no-cache'});
//changed
    //public headers = new Headers({'Content-Type': 'application/json','apiKey':'AIzaSyDnTiD1XwEfvVYZCk6I_i5M59lDKZpqH6o'});
	constructor(private http: Http,private router: Router,private LoaderService: LoaderService, private dialog: MdDialog,public sessionHandler : SessionHandler, private authService: AuthService) {
        this.authService.authState.subscribe((user) => {
            if(user != null)
			    this.id_token = user.idToken;
        });
    }

	getRequest(url) : Observable<Response[]> {
        this.headers = this.addAccessToken(this.headers);
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
            this.showLoader();
            return this.http.get(this.url +"/"+url,{headers: this.headers})
                         .map((res:Response) => this.errorCheckFunction(res.json(),'api'))
                         .catch((error:any) => Observable.throw(this.handleError(error,'api') || 'Server error'));
    }
    getRequestWithHeader(url,header) : Observable<Response[]> {
        header = this.addAccessToken(header);
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
            this.showLoader();
            return this.http.get(this.url +"/"+url,header)
                         .map((res:Response) => this.errorCheckFunction(res.json(),'api'))
                         .catch((error:any) => Observable.throw(this.handleError(error,'api') || 'Server error'));
    }
    getRequestWithHeaderTest(url,header) : Observable<Response[]> {
        header = this.addAccessToken(header);
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
            this.showLoader();
            return this.http.get(url,header)
                         .map((res:Response) => this.errorCheckFunction(res.json(),'api'))
                         .catch((error:any) => Observable.throw(this.handleError(error,'api') || 'Server error'));
    }
	getRequestWithoutLoader(url) : Observable<Response[]> {
        this.headers = this.addAccessToken(this.headers);
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
            return this.http.get(this.url +"/"+url,{headers: this.headers})
                         .map((res:Response) => this.errorCheckFunction(res.json(),'api'))
                         .catch((error:any) => Observable.throw(this.handleError(error,'api') || 'Server error'));
	}

    postRequest(body: Object,api:string): Observable<Response[]> {
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        this.showLoader();
        let bodyString = JSON.stringify(body);
        let headers      = new Headers({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*'});
        this.addAccessToken(headers);
        let options       = new RequestOptions({ headers: headers });

        return this.http.post(this.url+"/"+api, bodyString, options)
                        .map((res:Response) => this.errorCheckFunction(res,api))
                        .catch((error:any) => Observable.throw(this.handleError(error,api) || 'Server error'))
    }

    postRequestWithHeader(body: Object,api:string,header): Observable<Response[]> {
        header = this.addAccessToken(header);
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        this.showLoader();
        let bodyString = JSON.stringify(body);
        // let headers      = new Headers({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*'});
        // let options       = new RequestOptions({ headers: headers });


        return this.http.post(this.url+"/"+api, bodyString, header)
                        .map((res:Response) => this.errorCheckFunction(res,api))
                        .catch((error:any) => Observable.throw(this.handleError(error,api) || 'Server error'))
    }
    public checkSession(){
      
        // let timestamp = localStorage.getItem('timestamp');
        
        let userEmail = localStorage.getItem('userEmail');
        let user = localStorage.getItem("user");
        if(userEmail==null || userEmail =="" || user==null || user == ""){
            return false;
        }
        return true;
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;
        
    }

    public showSessionError(){
       
        //this.router.navigateByUrl('/extra/login');
    }
    

	public onEnd(): void {
        this.hideLoader();
    }

    public showLoader(): void {
        this.LoaderService.show();
    }
    public hideLoader(): void {
        this.LoaderService.hide();
    }

    public handleError(e: any,api) {
        console.log(e);
		let errorJson = e;
        if(errorJson.error && api != 'userOperationsApi/v1/login') {
            this.dialogRef = this.dialog.open(dialogComponent,{disableClose:true});
			this.dialogRef.componentInstance.msg = errorJson.error.errors[0].message;
        }
		if(errorJson.error && api == 'userOperationsApi/v1/login') {
            // this.dialogRef = this.dialog.open(dialogComponent);
            // this.dialogRef.componentInstance.msg = errorJson.error.message;
			alert(errorJson.error.message);
        }
        if(errorJson.error){
            alert("error in http req");
        }
        this.hideLoader();
        return false;
    }
	    //Dialog to capture error for authorization
    public errorCheckFunction(jsonResult, api){
        if(jsonResult == -401){
            window.location.reload();
        }
		return jsonResult;
    }

    private addAccessToken(header:Headers){
        if((header as any).headers != undefined){
            (header as any).headers.set('authtoken',this.id_token);
        }
        
        return header;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/http.service.ts